module.exports = __webpack_public_path__ + "img/46.87790f65.png";